import { matchPath } from 'react-router-dom';

import { getQueryParams } from 'constants/helper';

import { routes } from './routes';

const RABBIT_REDIRECT_PATHS = {
  [routes.performanceReview.index]: routes.performanceReview.audit,

  [routes.settings.review.questions]: '/moduleSettings?module=status&activeTabId=question_library',
  [routes.settings.review.reviewTemplate.list]: '/moduleSettings?module=status&activeTabId=templates',
  [routes.settings.review.reviewProcess]: '/moduleSettings?module=status&activeTabId=review_cycles',
  [routes.settings.review.reviewSettings]: '/moduleSettings?module=status&activeTabId=calibration_settings',

  [routes.settings.engagement.questions]: '/moduleSettings?module=engagement&activeTabId=question_library',
  [routes.settings.engagement.templates]: '/moduleSettings?module=engagement&activeTabId=templates',
  [routes.settings.engagement.drivers]: '/moduleSettings?module=engagement&activeTabId=engagement_drivers',
  [routes.settings.engagement.pulseSurvey]: '/moduleSettings?module=engagement&activeTabId=engagement_surveys',

  [routes.settings.checkIn.questions]: '/moduleSettings?module=oneOnOne&activeTabId=question_library',
  [routes.settings.checkIn.templates]: '/moduleSettings?module=oneOnOne&activeTabId=templates',
  [routes.settings.checkIn.preferences]: '/moduleSettings?module=oneOnOne&activeTabId=my_preferences',
  [routes.settings.checkIn.settings]: '/moduleSettings?module=oneOnOne&activeTabId=settings',
  [routes.settings.checkIn.calendar]: '/moduleSettings?module=oneOnOne&activeTabId=calendar',

  [routes.settings.meshTags]: '/moduleSettings?module=initiative&activeTabId=tags',
  [routes.settings.objectiveSettings]: '/moduleSettings?module=goal&activeTabId=settings',

  // OneOnOne is working properly

  [routes.oneOnOne.index]: routes.oneOnOne.audit,

  [routes.managers.team]: {
    initiatives: routes.initiative.audit,
    goals: routes.goals.audit,
  },
};

export const rabbitRedirectCheck = ({ location }) => {
  const { pathname, search } = location;
  const REDIRECT_OBJECT = RABBIT_REDIRECT_PATHS;

  let matchedRoute = null;
  let matchedTargetRoute = null;

  for (const [source, target] of Object.entries(REDIRECT_OBJECT)) {
    // @srivastavaAbhishek01: had to do this for goals / initaitive as
    // they share common routes and was differentiated on the basis of querystring
    if (source === routes.managers.team) {
      const { isGoalsPage, isInitiativesPage } = getQueryParams(search);
      if (isInitiativesPage) {
        matchedRoute = source;
        matchedTargetRoute = target.initiatives;
        break;
      } else if (isGoalsPage) {
        matchedRoute = source;
        matchedTargetRoute = target.goals;
        break;
      }
    }
    const match = matchPath(pathname, {
      path: source,
      exact: true,
    });
    if (match) {
      matchedRoute = source;
      matchedTargetRoute = target;
      break;
    }
  }

  return matchedTargetRoute;
};
